import { render, staticRenderFns } from "./AgentCard.vue?vue&type=template&id=1f2cf4f4"
import script from "./AgentCard.vue?vue&type=script&lang=js"
export * from "./AgentCard.vue?vue&type=script&lang=js"
import style0 from "./AgentCard.vue?vue&type=style&index=0&id=1f2cf4f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports